define('meetings/lib/telemetry-client/telemetry-service',['require','exports','module','@getgo/telemetry-client/jquery-buffered-queue','@getgo/telemetry-client/telemetry','web-urls','package-data','uuid','user-agent'],function (require, exports, module) {
    var transportFactory = require('@getgo/telemetry-client/jquery-buffered-queue');
    var telemetryFactory = require('@getgo/telemetry-client/telemetry');
    var webUrls = require('web-urls');
    var packageData = require('package-data');
    var UUID = require('uuid');
    var UA = require('user-agent')();

    function TelemetryService() {
        var self = this;

        var telemetryUrl = webUrls.get('telemetryUrl') + '/reportEvent';
        var telemetryOptions;
        var telemetry;
        var transport;

        function getTimezone(date) {
            var offsetMins = date.getTimezoneOffset();
            var hour = offsetMins > 0 ? Math.floor(offsetMins / 60) : Math.ceil(offsetMins / 60);
            var mins = offsetMins % 60 > 0 ? offsetMins % 60 : '';
            var offset = (parseInt(hour.toString() + mins.toString(), 10) * -100).toString();
            var formattedTimezone = offset.split('');
            formattedTimezone.splice(-2, 0, ':');

            // returns in format "-07:00"
            return formattedTimezone.join('');
        }

        packageData.retrieveConfig().then(function (data) {
            telemetryOptions = {
                // @eventAspects
                // https://confluence.ops.expertcity.com/display/Arch/eventAspects
                // 'ev_time': {Number},              // Generated by telemetry-client
                // 'ev_index': {Number}              // Generated by telemetry-client
                // 'ev_name': {String}               // Provided by API caller

                ev_source: 'Citrix.gotomeeting.MFE',
                ev_namespace: 'global',
                ev_schema_name: 'ep_telemetry',
                ev_schema_ver: 0,
                // 'ts_rectime': {Object},           // Generated by Telemetry REST server
                // 'ts_pubip': {Object},             // Generated by Telemetry REST server

                id_run: UUID.uuid,
                id_dev: UUID.machineId,

                //  @globalEventMeasures
                //  https://confluence.ops.expertcity.com/display/Arch/globalEventMeasures
                sw_prod_name: 'GoToMeeting MFE',
                sw_plat: navigator && navigator.platform,
                sw_build: data.version,
                sw_prod_ver: data.version,

                hw_model_id: 'NA for Browser',
                hw_model_name: 'NA for Browser',
                hw_net: 'NA for Browser',

                os_arch: navigator && navigator.platform,
                os_locale: navigator && (navigator.language || navigator.userLanguage),
                os_type: UA.os.simpleName,
                os_tz: getTimezone(new Date()),
                os_ver: UA.os.version,

                ga_browserName: UA.browser.simpleName,
                ga_browserVersion: UA.browser.version

                // REQUIRED EVENTS
                // @joinStart
                // https://wiki/display/Arch/joinStart
                // 'sa_method': ''
                // 'ga_meetingId': ''
                // 'ga_id_sessiontracking': ''
            };

            transport = transportFactory.createTransport(telemetryUrl, telemetryOptions);
            telemetry = telemetryFactory.createClient(transport.add.bind(transport), telemetryOptions);
        });

        self.report = function (event) {
            if (event && event.hasOwnProperty('ev_name')) {
                Object.assign(event, telemetryOptions);
                // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
                telemetry.event(event.ev_name, event);
                transport.flush();
                // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
            }
        };

        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }

        self.getSessionTracking = function (sourceParam) {
            return sourceParam + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        };
    }

    module.exports = new TelemetryService();
});

